/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S3_Services_LabelInputs */

const tr_mesafeli_s3_services_label = /** @type {(inputs: Mesafeli_S3_Services_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hizmetler:`)
};

const en_mesafeli_s3_services_label = /** @type {(inputs: Mesafeli_S3_Services_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Services:`)
};

const de_mesafeli_s3_services_label = /** @type {(inputs: Mesafeli_S3_Services_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leistungen:`)
};

const ru_mesafeli_s3_services_label = /** @type {(inputs: Mesafeli_S3_Services_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Услуги:`)
};

/**
* | output |
* | --- |
* | "Services:" |
*
* @param {Mesafeli_S3_Services_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s3_services_label = /** @type {((inputs?: Mesafeli_S3_Services_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S3_Services_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s3_services_label(inputs)
	if (locale === "de") return de_mesafeli_s3_services_label(inputs)
	if (locale === "ru") return ru_mesafeli_s3_services_label(inputs)
	return tr_mesafeli_s3_services_label(inputs)
});